import { ComponentPropsWithoutRef, ForwardedRef, forwardRef } from 'react';
import { first } from 'lodash';
import sanitizeHtml from 'sanitize-html';
import { twMerge } from 'tailwind-merge';
import { EngageMessage } from 'types/domain';

interface SmsMessagePreviewProps extends ComponentPropsWithoutRef<'div'> {
    message: EngageMessage;
}
const SmsMessagePreview = forwardRef(
    (
        { message, className, ...restProps }: SmsMessagePreviewProps,
        forwardedRef: ForwardedRef<HTMLDivElement>,
    ) => {
        const image = first(message.media);
        const body = message.body ?? '';

        return (
            <div
                className={twMerge(
                    'relative mx-auto h-[576px] w-72',
                    `bg-[url('/images/screenshots/iphone-screenshot.svg')]`,
                    className,
                )}
                ref={forwardedRef}
                {...restProps}
            >
                <div className="absolute left-10 right-10 top-16 flex items-center justify-center gap-1 text-[10px]">
                    {message.sender?.value} <span className="text-sm text-gray-400">&rsaquo;</span>
                </div>
                <div className="absolute left-10 right-10 top-24 flex max-h-[540px] flex-col items-start gap-4 overflow-y-auto overflow-x-hidden">
                    {image ? (
                        <img
                            src={image.url}
                            className="h-auto max-h-28 max-w-full"
                            alt={image.name}
                        />
                    ) : null}
                    {body.trim().length > 0 ? (
                        <div
                            className="max-w-52 whitespace-pre-line break-words rounded-2xl bg-green-400 p-3 text-sm leading-4 text-white"
                            dangerouslySetInnerHTML={{
                                __html:
                                    sanitizeHtml(body, {
                                        allowedTags: ['code', 'p'],

                                        allowedAttributes: {},
                                    }) + '\n\nReply STOP to opt out. Msg&data rates may apply.',
                            }}
                        />
                    ) : (
                        <p className="mt-10 w-full text-center text-xs text-gray-500">
                            Add a message to preview
                        </p>
                    )}
                </div>
            </div>
        );
    },
);

export { SmsMessagePreview };
